import { Link } from 'react-router';

import './TopNav.css'

function TopNav() {
	return (
		<nav className="topnav">
			<div className="logo"><span>Eyes on</span> Environmental Enforcement</div>

			<div className="nav-links">
				<Link to="/">Home</Link>
				<Link to="portal">Search Portal</Link>
				<Link to="why-this-matters">Why This Matters</Link>
				<Link to="project-background">Project Background</Link>
				<Link to="about-data">Data Info & Caveats</Link>
				<Link to="curation-notes">Caveats & Curation Notes</Link>
				<Link to="uses">Suggested Uses</Link>
				<Link to="collaborators">Collaborators</Link>
				<Link to="contact">Report A Data Issue</Link>
			</div>
		</nav>
	)
}

export default TopNav;

/* 

SOME WEIRDNESS

- got rid of the Search Information page (now part of Data info & Caveats)
- the names are almost too long now
- Caveats and Caveats
- Have no sub title for Caveats and Curation Notes

*/
